import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { ITag } from '../types/generated'

/**
 * Fetch a single Tag from Contentful
 *
 * @param {string} slug The slug of this Tag
 */
export const fetchTag = async (slug: string): Promise<ITag | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'tag',
      'fields.slug': slug,
      include: 5,
    }),
  ) as ITag | undefined
}

/**
 * Fetch all Tag from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchTags = async (
  query?: Record<string, unknown>,
): Promise<ITag[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      order: 'fields.title',
      ...query,
      content_type: 'tag',
    }),
  ) as ITag[]
}
